export const renderTags = (text, tags) => (!text || !tags ? text : text.replace(/\{([A-Za-z]+)\}/g, (m, k) => tags[k.toUpperCase()] ?? m));
export const hasTags = (text) => /\{[A-Za-z]+\}/.test(text || "");
